import { render } from "./Board.vue?vue&type=template&id=68b16797&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-68b16797"

export default script